/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Cloud API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';

import type { ApiResponseFilterItem } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getFilters
 */
export const getV8CloudAwsCostExplorerFilter = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseFilterItem>(
    { url: `/api/v8/cloud/aws/cost-explorer/filter`, method: 'GET', signal },
    options,
  );
};

export const getGetV8CloudAwsCostExplorerFilterQueryKey = () => {
  return ['api', 'v8', 'cloud', 'aws', 'cost-explorer', 'filter'] as const;
};

export const getGetV8CloudAwsCostExplorerFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8CloudAwsCostExplorerFilter>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV8CloudAwsCostExplorerFilter>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8CloudAwsCostExplorerFilterQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8CloudAwsCostExplorerFilter>>> = ({
    signal,
  }) => getV8CloudAwsCostExplorerFilter(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8CloudAwsCostExplorerFilter>>,
    TError,
    TData
  >;
};

export type GetV8CloudAwsCostExplorerFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8CloudAwsCostExplorerFilter>>
>;
export type GetV8CloudAwsCostExplorerFilterQueryError = ErrorType<unknown>;

/**
 * @summary getFilters
 */

export function useGetV8CloudAwsCostExplorerFilter<
  TData = Awaited<ReturnType<typeof getV8CloudAwsCostExplorerFilter>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8CloudAwsCostExplorerFilter>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8CloudAwsCostExplorerFilterQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
